import * as React from "react";
import { Link } from "@/components/common/Link";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { FileText, ShieldCheck } from "lucide-react";
const candidates = [{
  firstName: "FAZIO",
  lastName: "Simone Bruno"
}, {
  firstName: "ALERA",
  lastName: "Giulia"
}, {
  firstName: "BACCHIEGA",
  lastName: "Andrea"
}, {
  firstName: "BASEI",
  lastName: "Giorgio"
}, {
  firstName: "BATTAGIN",
  lastName: "Giulia"
}, {
  firstName: "BATTIATO",
  lastName: "Alessandra"
}, {
  firstName: "BOTTONI",
  lastName: "Alessandra"
}, {
  firstName: "CICCONI",
  lastName: "Damiano"
}, {
  firstName: "CIMINI",
  lastName: "Alessandra"
}, {
  firstName: "FRANCUCCI",
  lastName: "Irene"
}, {
  firstName: "GAZZIERO",
  lastName: "Valentina"
}, {
  firstName: "IACOANGELI",
  lastName: "Gioia"
}, {
  firstName: "LORENZETTI",
  lastName: "Marco"
}, {
  firstName: "NADINI",
  lastName: "Deborah"
}, {
  firstName: "PALOMBI",
  lastName: "Alberto"
}, {
  firstName: "PEPPE",
  lastName: "Barbara"
}, {
  firstName: "PEDE",
  lastName: "Fabrizio"
}, {
  firstName: "POLISE",
  lastName: "Michela"
}, {
  firstName: "ROSCIOLI",
  lastName: "Federica"
}, {
  firstName: "SALVIONI",
  lastName: "Arianna"
}, {
  firstName: "SIMONETTI",
  lastName: "Anna"
}, {
  firstName: "SPACCATROSI",
  lastName: "Liana"
}, {
  firstName: "SPITONI",
  lastName: "Paolo"
}, {
  firstName: "TARICIOTTI",
  lastName: "Giusy"
}];
export default function CandidatesList1() {
  return <section id="candidati-lista-1" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="mb-10 text-center">
          <h2 className="font-default text-3xl md:text-4xl font-bold text-foreground mb-4">Candidati Casa Riformista</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Elenco ufficiale dei candidati. In ottemperanza alle normative sulla trasparenza, 
            sono disponibili per la consultazione i Curriculum Vitae e i certificati del Casellario Giudiziale di ciascun candidato.
          </p>
        </div>

        <div className="rounded-md border border-border bg-card shadow-sm overflow-hidden">
          <Table>
            <TableHeader className="bg-muted/50">
              <TableRow>
                <TableHead className="w-[50px] text-center font-semibold">#</TableHead>
                <TableHead className="font-semibold">Candidato</TableHead>
                <TableHead className="text-right font-semibold">Documentazione</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {candidates.map((candidate, i) => <TableRow key={i} data-index={i} className="even:bg-muted/20 hover:bg-muted/50 transition-colors">
                  <TableCell className="text-center text-muted-foreground font-medium">
                    {i + 1}
                  </TableCell>
                  <TableCell className="font-medium text-foreground">
                    {candidate.firstName} {candidate.lastName}
                  </TableCell>
                  <TableCell className="text-right">
                    <div className="flex items-center justify-end gap-2">
                      <Button variant="outline" size="sm" asChild className="h-8 text-xs">
                        <Link to="#">
                          <FileText className="size-3.5 mr-1.5" />
                          CV
                        </Link>
                      </Button>
                      <Button variant="outline" size="sm" asChild className="h-8 text-xs">
                        <Link to="#">
                          <ShieldCheck className="size-3.5 mr-1.5" />
                          Casellario
                        </Link>
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>)}
            </TableBody>
          </Table>
        </div>

        <div className="mt-12 text-center">
          <Button variant="default" size="lg" asChild>
            <Link to="/CoalitionPage">
              Torna alla coalizione
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}